{
  "equipment": "Equipment",
  "rate_day": "Rate/day",
  "rate_week": "Rate/week",
  "qty": "Quantity",
  "rent_period": "Rent period",
  "add_equipment": "Add equipment",
  "search": "Search"
}
